import { useContext, useState, useEffect } from 'react';
import ReactModal from 'react-modal';
import { useHistory } from 'react-router-dom';
import PageLayout from '../Layouts/PageLayout';
import { UserContext } from '../context/AuthContext';
import { useDispatch } from 'react-redux';
import Select from 'react-select';
import UserCartData from './UserCartData';
import { getCheckout, placeCheckout, promocode, getPaymentMethods, placeManualCheckout } from '../services/checkout';
import { getAddressesList, addAddressApi, updateAddressApi } from '../services/address';
import {
    getGovernorates,
    hasLegacyNumericArea,
    KUWAIT_COUNTRY_ID,
    resolveLegacyArea,
    toAddressPayload,
} from '../Utils/addressUtils';
import Loader from '../Common/Loader';
import { scrollToSelector, showError, showSuccess } from '../Utils/helper';
import { ToastContainer } from 'react-toastify';
import { Trans, useTranslation } from 'react-i18next';
import { getStudentCredit } from '../services/student';
import AddAddress from '../addresses/addAddress';
import ManualPaymentSuccessModal from '../modals/ManualPaymentSuccessModal';
import { usePageTitle } from '../../hooks/usePageTitle';
/**
 *
 * @param {Checkout} author by Bilal
 * @returns
 */

const customStyles = {
    padding: '5px 0px',
    borderRadius: '11px',
    borderCcolor: 'red',
};

const formatAddress = (item) =>
    `${item?.apartment !== null ? `Apartment: ${item?.apartment},` : ''} House: ${item?.house}, Street: ${item?.street}, Area: ${item?.city}, Governorate: ${item?.state} - ${item?.country?.name}`;

const toAddressOption = (item) => ({
    value: item.id,
    label: item.category,
    address: formatAddress(item),
    item,
});

function Checkout() {
    const dispatch = useDispatch();
    usePageTitle('Checkout')
    const { t, i18n } = useTranslation();
    const history = useHistory();
    const [courseCart, setCourseCart] = useState(null);
    const [loading, setLoading] = useState(true);
    const [spinner, setSpinner] = useState(false);
    const { user, loggedIn, loadingUser } = useContext(UserContext);
    const [total, setTotal] = useState(null);
    const [subtotal, setSubtotal] = useState(null);
    const [promocodeTotal, setPromocodeTotal] = useState(null);
    const [finalTotal, setFinalTotal] = useState(null);
    const [currencyCode, setCurrencyCode] = useState('KWD');

    const [promo, setPromo] = useState('');
    const [promoCode, setPromoCode] = useState('');
    const [courseList, setCourseList] = useState([]);
    const [displayAddress, setDisplayAddress] = useState('');
    const [addressName, setAddressName] = useState({
        value: '',
        label: '',
    });
    const [addresses, setAddresses] = useState([]);
    const userCountryId = user?.country_id;
    // only addresses in the user's country can be used for checkout
    const countryAddresses = addresses.filter((option) => +option.item.country_id === +userCountryId);

    // legacy Kuwait addresses have no governorate stored, so the user re-picks the area inline
    const [fixGovernorate, setFixGovernorate] = useState(null);
    const [fixArea, setFixArea] = useState(null);
    const isArabic = i18n.language === 'ar';
    const needsAreaFix = hasLegacyNumericArea(addressName?.item);
    const kuwaitGovernorates = getGovernorates(KUWAIT_COUNTRY_ID, isArabic);
    const governorateOptions = Object.keys(kuwaitGovernorates).map((item) => ({ label: item, value: item }));
    const areaOptions = (kuwaitGovernorates[fixGovernorate?.value] || []).map((item) => ({ label: item, value: item }));
    const [details, setDetails] = useState({
        first_name: user?.first_name,
        last_name: user?.last_name,
        email: user?.email,
        mobile_number: user?.mobile_number,
        country_id: 112,
        address_line1: '',
        address2: '',
        address3: '',
        address3: '',
        //kuwait
        block: '',
        street: '',
        house: '',
        apartment: '',
        driections: '',
        area: '',
        credit_applied: 0,
    });

    const [userCredit, setUserCredit] = useState(0);
    const [creditApplied, setCreditApplied] = useState(0);

    const [countryId, setCountryId] = useState(null);
    const [paymentMethod, setPaymentMethod] = useState('online');
    const [manualPaymentMethods, setManualPaymentMethods] = useState([]);
    const [selectedManualPaymentMethod, setSelectedManualPaymentMethod] = useState(null);
    const [loadingPaymentMethods, setLoadingPaymentMethods] = useState(false);
    const [orderData, setOrderData] = useState(null);
    const [showManualPaymentSuccessModal, setShowManualPaymentSuccessModal] = useState(false);

    useEffect(() => {
        setLoading(true);
        if (loggedIn) {
            getAddresses();
            getCheckoutDetails();
        } else {
            history.push('/login');
            return null;
        }
    }, []);

    async function getPaymentMethodsDetails() {
        setLoadingPaymentMethods(true);
        const resp = await getPaymentMethods();
        if (resp.success) {
            setManualPaymentMethods(resp.data);
        } else {
            console.log('Error fetching payment methods');
        }
        setLoadingPaymentMethods(false);
    }

    useEffect(() => {
        if (loggedIn && countryId === 107) {
            getPaymentMethodsDetails();
        }
    }, [countryId, loggedIn]);

    function changeHandler(e) {
        const { name, value } = e.target;

        setDetails({
            ...details,
            [name]: value,
        });
    }
    async function getCheckoutDetails() {
        const resp = await getCheckout();
        if (resp.success) {
            setTotal(Number(resp.data.total));
            setSubtotal(Number(resp.data.subtotal));
            setPromocodeTotal(Number(resp.data.discount_total));
            setFinalTotal(Number(resp.data.total));
            setCurrencyCode(resp.data.currency_code);
            let _arr = [];
            resp.data.items.map((_item) => {
                _arr.push(_item.product_id);
            });
            setCountryId(user?.country_id || 112);
            setCourseList(_arr);
            setCourseCart(resp.data.items);
        } else {
            showError(t('alertMessage.wrong'));
        }
        setLoading(false);
    }

    async function getAddresses() {
        setLoading(true);
        const resp = await getAddressesList();
        if (resp.success) {
            setAddresses(resp.data.map(toAddressOption));
        } else {
            showError(t('alertMessage.wrong'));
        }
        setLoading(false);
    }

    const selectAddressOption = (option) => {
        setAddressName(option);
        setDisplayAddress(option.address);
    };

    // persists the resolved names so the address is fixed for good, then selects it
    async function saveResolvedArea(item, { state, city }) {
        setSpinner(true);
        const resp = await updateAddressApi(item.id, toAddressPayload(item, { state, city }));
        setSpinner(false);
        if (resp?.success) {
            const updated = toAddressOption({ ...item, state, city });
            setAddresses((list) => list.map((option) => (option.value === item.id ? updated : option)));
            selectAddressOption(updated);
            setFixGovernorate(null);
            setFixArea(null);
        } else {
            showError(t('alertMessage.wrong'));
        }
    }

    const handleSelectAddress = (option) => {
        setFixGovernorate(null);
        setFixArea(null);
        selectAddressOption(option);
        const resolved = resolveLegacyArea(option.item, isArabic);
        if (resolved) {
            saveResolvedArea(option.item, resolved);
        }
    };

    async function getCredit() {
        const resp = await getStudentCredit(user?.id);
        if (resp.success) {
            return resp;
        } else {
            console.log(resp);
            throw new Error('Could not fetch credit');
        }
    }

    useEffect(() => {
        setDetails({
            ...details,
            first_name: user?.first_name,
            last_name: user?.last_name,
            email: user?.email,
            mobile_number: user?.mobile_number,
        });

        getCredit()
            .then((res) => {
                setUserCredit(Number(res.data[0].credit_balance));
            })
            .catch((err) => console.log(err));
    }, [user]);

    useEffect(() => {
        localStorage.removeItem('update_cart');
    }, []);

    async function placeholder(e) {
        e.preventDefault();
        setSpinner(true);
        if (!loggedIn) {
            showError(t('alertMessage.signUpToPurchase'));
            return;
        }
        if (needsAreaFix) {
            showError(t('alertMessage.areaNeedsUpdate'), 3000, 'top-center');
            scrollToSelector('address');
            setSpinner(false);
            return;
        }
        Object.entries(details).map((_item) => {
            if (_item[1] === '') {
                delete details[_item[0]];
            }
        });

        details['applied_promocode'] = promoCode;
        details['cart_course'] = courseList;
        details['total'] = finalTotal.toString();
        details['promocode_total'] = promocodeTotal;
        details['final_total'] = finalTotal.toString();
        details['address_id'] = addressName.value;
        details['country_id'] = countryId;
        details['credit_applied'] = creditApplied.toString();

        let resp;
        if (paymentMethod === 'manual') {
            if (!selectedManualPaymentMethod) {
                showError(t('alertMessage.selectPaymentMethod'));
                setSpinner(false);
                return;
            }
            resp = await placeManualCheckout(details);
            if (resp.success) {
                setOrderData(resp.data);
                setSpinner(false);
                setShowManualPaymentSuccessModal(true);
                return;
            }
        } else {
            resp = await placeCheckout(details);
        }

        if (!resp?.success) {
            if (resp?.message?.address_id?.[0]) {
                showError(t('alertMessage.validAddress'), 3000, 'top-center');
                scrollToSelector('address');
                setSpinner(false);
                return false;
            }
        }

        if (paymentMethod === 'manual') {
            return;
        }

        if (resp?.redirect_url) {
            // NOTE(aalhendi): free course workaround
            showSuccess('Order processed successfully!');
            setTimeout(() => {
                window.location.href = resp.redirect_url;
            }, 1000);
        } else if (resp?.transaction?.url) {
            // NOTE(aalhendi): paid course - redirect to payment gateway
            window.open(resp.transaction.url, '_self');
        } else {
            showError('Error');
        }
        setSpinner(false);
    }

    async function applyPromoCode(e) {
        e.preventDefault();
        if (!promo) {
            showError(t('alertMessage.enterPromo'));
            return;
        }
        if (!loggedIn) {
            showError(t('alertMessage.signUpToPurchase'));
            return;
        }
        let payload = {
            cart_course: courseList,
            code: promo,
        };
        const resp = await promocode(payload);
        if (resp.success) {
            if (resp.data === finalTotal) {
                showError(t('alertMessage.promoCodeDoesNotExist'));
                return;
            }
            setFinalTotal(Number(resp.data));
            setPromocodeTotal(subtotal - Number(resp.data));
            showSuccess(t('alertMessage.success'));
            setPromoCode(promo);
            setPromo('');
        } else {
            showError(t('alertMessage.invalidPromoCode'));
        }
    }

    function applyCredit(e) {
        e.preventDefault();

        if (!loggedIn) {
            showError(t('alertMessage.signUpToPurchase'));
            return;
        }

        if (userCredit > 0 && finalTotal > 0) {
            if (finalTotal - userCredit < 0) {
                setUserCredit(Number(userCredit - finalTotal));
                setCreditApplied(finalTotal);
                setFinalTotal(0);
            } else {
                setFinalTotal(finalTotal - userCredit);
                setCreditApplied(userCredit);
                setUserCredit(0);
            }
        }
    }

    function removeCredit(e) {
        e.preventDefault();
        setUserCredit(Number(userCredit + creditApplied));
        setFinalTotal(finalTotal + creditApplied);
        setCreditApplied(0);
    }

    // Add this new function to handle address addition
    const handleAddAddress = async (newAddress) => {
        try {
            const resp = await addAddressApi(newAddress);
            if (resp.success) {
                const updatedAddresses = await getAddressesList();
                if (updatedAddresses.success) {
                    const addressOptions = updatedAddresses.data.map(toAddressOption);
                    setAddresses(addressOptions);

                    // Find and select the newly added address
                    const newAddressOption = addressOptions.find((addr) => addr.value === resp.data.id);
                    if (newAddressOption) {
                        selectAddressOption(newAddressOption);
                    }
                }
                showSuccess(t('alertMessage.addressAdded'));
            } else {
                showError(t('alertMessage.addressAddFailed'));
            }
        } catch (error) {
            console.error('Error adding address:', error);
            showError(t('alertMessage.addressAddFailed'));
        }
    };

    return (
        <>
            {loading && loadingUser && courseCart ? (
                <Loader />
            ) : (
                <PageLayout>
                    <section className="mt_50">
                        <form onSubmit={placeholder}>
                            <div className="container">
                                <h1 className="blue_title">{t('common.checkout')}</h1>
                                <div className="row" dir={i18n.language == 'ar' ? 'rtl' : 'ltr'}>
                                    <div className="col-12 col-lg-4">
                                        <div className="cart_wrapper">
                                            <h2>{t('checkout.billing_details')}</h2>
                                            <div className="form-group">
                                                <label for="">{t('common.firstName')}</label>
                                                <input
                                                    type="text"
                                                    name=""
                                                    id=""
                                                    className="form-control"
                                                    value={user?.first_name}
                                                    disabled
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label for="">{t('common.lastName')}</label>
                                                <input
                                                    type="text"
                                                    name=""
                                                    id=""
                                                    className="form-control"
                                                    value={user?.last_name}
                                                    disabled
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label for="">{t('common.email')}</label>
                                                <input
                                                    type="email"
                                                    name=""
                                                    id=""
                                                    className="form-control"
                                                    value={user?.email}
                                                    disabled
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label className="required-field">{t('common.mobileNumber')}</label>
                                                <input
                                                    type="number"
                                                    name="mobile_number"
                                                    className="form-control"
                                                    value={details?.mobile_number}
                                                    onChange={changeHandler}
                                                    required
                                                    placeholder={t('common.mobileNumber')}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-4">
                                        <div className="cart_wrapper">
                                            {countryAddresses.length > 0 ? (
                                                <div className="form-group">
                                                    <label className="required-field" id="address">
                                                        {t('common.selectAddress')}
                                                    </label>
                                                    <Select
                                                        name="form-field-name"
                                                        className="react_select"
                                                        value={addressName}
                                                        onChange={handleSelectAddress}
                                                        options={countryAddresses}
                                                        styles={customStyles}
                                                        required
                                                    />
                                                    {displayAddress !== '' ? (
                                                        <p className="note mt-3">
                                                            {t('common.address')} <span>{displayAddress}</span>
                                                        </p>
                                                    ) : (
                                                        ''
                                                    )}
                                                    {needsAreaFix && (
                                                        <div className="mt-3">
                                                            <p className="text-danger">
                                                                {t('alertMessage.areaNeedsUpdate')}
                                                            </p>
                                                            <div className="form-group">
                                                                <label className="required-field">
                                                                    {t('common.governorate')}
                                                                </label>
                                                                <Select
                                                                    placeholder={t('common.select')}
                                                                    options={governorateOptions}
                                                                    className="react_select"
                                                                    value={fixGovernorate}
                                                                    onChange={(selected) => {
                                                                        setFixGovernorate(selected);
                                                                        setFixArea(null);
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="form-group">
                                                                <label className="required-field">
                                                                    {t('common.chooseArea')}
                                                                </label>
                                                                <Select
                                                                    placeholder={t('common.select')}
                                                                    options={areaOptions}
                                                                    className="react_select"
                                                                    value={fixArea}
                                                                    isDisabled={!fixGovernorate}
                                                                    onChange={(selected) => {
                                                                        setFixArea(selected);
                                                                        saveResolvedArea(addressName.item, {
                                                                            state: fixGovernorate.value,
                                                                            city: selected.value,
                                                                        });
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}
                                                    <br />
                                                    {displayAddress === '' && (
                                                        <AddAddress onAddAddress={handleAddAddress} countryId={userCountryId} />
                                                    )}
                                                </div>
                                            ) : (
                                                displayAddress === '' && <AddAddress onAddAddress={handleAddAddress} countryId={userCountryId} />
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-4">
                                        <div className="cart_wrapper mb_30">
                                            <h2>{t('checkout.payment_method')}</h2>
                                            <div className="form-group">
                                                <div className="pay_method">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="paymentMethod"
                                                        id="paymentMethodOnline"
                                                        checked={paymentMethod === 'online'}
                                                        onChange={() => setPaymentMethod('online')}
                                                    />
                                                    <label className="form-check-label" for="paymentMethodOnline">
                                                        {t('checkout.online_payment')}
                                                    </label>
                                                </div>
                                                {countryId === 107 && (
                                                    <div className="pay_method">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="paymentMethod"
                                                            id="paymentMethodManual"
                                                            checked={paymentMethod === 'manual'}
                                                            onChange={() => setPaymentMethod('manual')}
                                                        />
                                                        <label className="form-check-label" for="paymentMethodManual">
                                                            {t('checkout.manual_payment')}
                                                        </label>
                                                    </div>
                                                )}
                                            </div>
                                            {paymentMethod === 'manual' && !loadingPaymentMethods && (
                                                <div className="form-group mt-3">
                                                    <label className="required-field">
                                                        {t('checkout.select_manual_payment')}
                                                    </label>
                                                    {manualPaymentMethods.map((method) => (
                                                        <div key={method.id} className="pay_method mb-2">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="manualPaymentMethod"
                                                                id={`manualPaymentMethod_${method.id}`}
                                                                checked={selectedManualPaymentMethod?.id === method.id}
                                                                onChange={() => setSelectedManualPaymentMethod(method)}
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                for={`manualPaymentMethod_${method.id}`}
                                                            >
                                                                {method.alias} ({method.currency})
                                                            </label>
                                                        </div>
                                                    ))}
                                                    {selectedManualPaymentMethod && (
                                                        <div className="payment-details mt-3">
                                                            <div className="payment-details-box">
                                                                <p>
                                                                    <strong>{t('checkout.account_details')}:</strong>{' '}
                                                                    {selectedManualPaymentMethod.account_details}
                                                                </p>
                                                                <p>
                                                                    <strong>{t('checkout.transfer_details')}:</strong>{' '}
                                                                    {selectedManualPaymentMethod.transfer_details}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                        <div className="cart_wrapper">
                                            <h2>{t('checkout.apply_promo_code')}</h2>
                                            <div className="form-group">
                                                <label for="">{t('checkout.promo_code')}</label>
                                                <div className="form_input">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder={t('checkout.enter_promo_code')}
                                                        value={promo}
                                                        onChange={(e) => setPromo(e.target.value)}
                                                    />
                                                    <a href="" className="link" onClick={applyPromoCode}>
                                                        {t('checkout.apply')}
                                                    </a>
                                                </div>
                                            </div>
                                            <h2>{t('checkout.applyCredit')}</h2>
                                            <div className="form-group">
                                                <label for="">{t('checkout.wallet')}</label>
                                                <div className="form_input">
                                                    <label className="form-control">
                                                        {countryId === 112
                                                            ? t('course.price_in_kd', {
                                                                price: userCredit,
                                                            })
                                                            : countryId === 17
                                                                ? t('course.price_in_bd', {
                                                                    price: userCredit,
                                                                })
                                                                : t('course.price_in_jd', {
                                                                    price: userCredit,
                                                                })}
                                                    </label>
                                                    {creditApplied <= 0 ? (
                                                        <a href="" className="link" onClick={(e) => applyCredit(e)}>
                                                            {t('checkout.apply')}
                                                        </a>
                                                    ) : null}
                                                    {creditApplied > 0 ? (
                                                        <a
                                                            href=""
                                                            className="link"
                                                            style={{
                                                                color: 'red',
                                                            }}
                                                            onClick={(e) => removeCredit(e)}
                                                        >
                                                            {t('common.remove')}
                                                        </a>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="cart_wrapper">
                                            <h2>{t('checkout.review_order')}</h2>
                                            {courseCart?.length === 0 ? (
                                                <span>{t('checkout.no_course_found')}</span>
                                            ) : (
                                                <div className="ro_wrapper">
                                                    <div className="ro_header">
                                                        <div className="ro_bold">{t('common.product')}</div>
                                                        <div className="ro_bold">{t('common.total')}</div>
                                                    </div>
                                                    <UserCartData cartArr={courseCart} countryId={countryId} />
                                                    <div className="ro_subtotal">
                                                        <div className="ro_subrow">
                                                            <div className="ro_bold">{t('checkout.subtotal')}</div>
                                                            <div className="ro_price">
                                                                {t('course.price_with_currency', {
                                                                    currency: currencyCode,
                                                                    price: subtotal,
                                                                })}
                                                            </div>
                                                        </div>
                                                        <div className="ro_subrow">
                                                            <div className="ro_bold">
                                                                {t('checkout.after_applying_code')}
                                                            </div>
                                                            <div className="ro_price">
                                                                {t('course.price_with_currency', {
                                                                    currency: currencyCode,
                                                                    price: promocodeTotal,
                                                                })}
                                                            </div>
                                                        </div>
                                                        <div className="ro_subrow">
                                                            <div className="ro_bold">
                                                                {t('checkout.credit_applied')}
                                                            </div>
                                                            <div className="ro_price">
                                                                {t('course.price_with_currency', {
                                                                    currency: currencyCode || 'KWD',
                                                                    price: creditApplied,
                                                                })}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="ro_total">
                                                        <div className="ro_bold">{t('common.total')}</div>
                                                        <div className="ro_price">
                                                            {t('course.price_with_currency', {
                                                                currency: currencyCode || 'KWD',
                                                                price: finalTotal,
                                                            })}
                                                        </div>
                                                    </div>

                                                    {countryAddresses.length > 0 ? (
                                                        <>
                                                            <div className="ro_check terms_condition">
                                                                <input
                                                                    className="form-check-input cursor_pointer"
                                                                    type="checkbox"
                                                                    id=""
                                                                    required
                                                                />
                                                                <label className="form-check-label">
                                                                    <Trans i18nKey="common.termsAndCondition">
                                                                        I have read and accept the
                                                                        <a
                                                                            className="link cursor_pointer"
                                                                            href="/terms-condition"
                                                                            target="_blank"
                                                                        >
                                                                            {' '}
                                                                            terms and conditions.
                                                                        </a>
                                                                    </Trans>
                                                                </label>
                                                            </div>
                                                        </>
                                                    ) : null}
                                                    <button
                                                        className="btn_primary big_btn full_btn"
                                                        type="submit"
                                                    >
                                                        {spinner && (
                                                            <span className="mr-2 spinner-border spinner-border-sm" />
                                                        )}
                                                        {t('common.placeOrder')}
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </section>
                    <ToastContainer />
                    {showManualPaymentSuccessModal && (
                        <ReactModal
                            isOpen
                            ariaHideApp={false}
                            className="react_modal manual_payment_success"
                            overlayClassName="modal_overlay"
                        >
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={() => setShowManualPaymentSuccessModal(false)}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <ManualPaymentSuccessModal
                                closeModal={() => setShowManualPaymentSuccessModal(false)}
                                orderData={orderData}
                                paymentMethod={selectedManualPaymentMethod}
                            />
                        </ReactModal>
                    )}
                </PageLayout>
            )}
        </>
    );
}

export default Checkout;
